<template>
  <span
    v-if="visible"
    class="support-ticket-priority"
    :class="`support-ticket-priority--${normalizedPriority}`"
    role="img"
    :aria-label="`${label} priority`"
    :title="showLabel ? null : `${label} priority`"
  >
    <svg v-if="normalizedPriority !== 'medium'" viewBox="0 0 16 16" aria-hidden="true">
      <path d="M3 8.5 8 3.5l5 5" />
      <path d="M3 12.5 8 7.5l5 5" />
    </svg>
    <svg v-else viewBox="0 0 16 16" aria-hidden="true">
      <path d="M3 6h10" />
      <path d="M3 10h10" />
    </svg>
    <span v-if="showLabel">{{ label }}</span>
  </span>
</template>

<script>
import { priorityLabel } from '../ticketState'

export default {
  name: 'SupportTicketPriorityIndicator',
  props: {
    priority: { type: String, default: 'medium' },
    showLabel: Boolean,
    hideMedium: Boolean
  },
  computed: {
    normalizedPriority() { return ['high', 'medium', 'low'].includes(this.priority) ? this.priority : 'medium' },
    label() { return priorityLabel(this.normalizedPriority) },
    visible() { return !this.hideMedium || this.normalizedPriority !== 'medium' }
  }
}
</script>

<style lang="scss" scoped>
.support-ticket-priority {
  display: inline-flex;
  min-width: 20px;
  align-items: center;
  gap: 5px;
  color: #778196;
  font-size: 12px;
  font-weight: 700;
  line-height: 18px;
  white-space: nowrap;
}

.support-ticket-priority svg {
  width: 18px;
  height: 18px;
  flex: 0 0 18px;
  overflow: visible;
  fill: none;
  stroke: currentColor;
  stroke-linecap: round;
  stroke-linejoin: round;
  stroke-width: 2.2;
}

.support-ticket-priority--high { color: #d14343; }
.support-ticket-priority--low { color: #2474d2; }
.support-ticket-priority--low svg { transform: rotate(180deg); }
</style>
